module.exports = __webpack_public_path__ + "img/livemap_editbeacons_childbeaconsexample3.7152c91f.png";